import { CANAL, APP_VERSION } from "../helpers/constants";
import { axiosInstance } from "../helpers/axios";

const getAnios = (user, id, securitykey) => {
  return axiosInstance
    .post("getModelosv2/", {
      usuario: user,
      canal: CANAL,
      version: APP_VERSION,
      ID: id,
      llaveSeguridad: securitykey,
    })
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      console.log("error");
      console.log(err.message);
    });
};

const getAniosSeguro = (user, id, securitykey) => {
  return axiosInstance
    .post("getModelosv2/", {
      usuario: user,
      canal: CANAL,
      version: APP_VERSION,
      ID: id,
      llaveSeguridad: securitykey,
      modulo: 2,
    })
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      console.log("error");
      console.log(err.message);
    });
};

export default { getAnios, getAniosSeguro };
